export const CLASSES_PER_PAGE = 10;
export const LEVELS_PER_PAGE = 10;
export const CLASS_STORAGE_KEY = "mt_admin_classes_v2";
/** Previous mock key — migrated automatically on first load */
export const CLASS_STORAGE_KEY_LEGACY = "mt_admin_classes_v1";

export const CLASS_LIMITS = {
  nameMax: 80,
  descriptionMax: 500,
  benefitTitleMax: 50,
  benefitDescriptionMax: 500,
  benefitsMax: 4,
  thumbnailMaxBytes: 25 * 1024 * 1024,
} as const;

export const CLASS_AGE_BANDS = [
  "10 years above",
  "10 years below",
  "10 Years above - Female",
  "10 years below - Male",
] as const;
